
























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchComposeLaonian extends Vue {
  @Prop()
  private message: any;
}
